import $ from 'jquery'

$(document).ready(function () {
    $(".colll").click(function(event) {
        const navbar = document.querySelector('.navbar-collapse');
        navbar.classList.remove('show');
    });
  });